import { AttributeRelation, OrderValues, RemoteConfig } from '@ca/common/types'
import { validateItem } from './validateItem'

const AttributeUtils = {
  resolveAttributes: ({
    attributes,
    config,
    values,
  }: {
    attributes: AttributeRelation[]
    config: RemoteConfig
    values: OrderValues
  }) => {
    const valid = attributes.filter((item) => {
      if (!item.requires) return true
      return validateItem(
        { requires: item.requires, condition: null },
        values.values,
        config.conditions,
        values.refraction ?? undefined
      ).result
    })

    return valid.map((item) => config.attributes?.[item.id]).filter((v) => !!v)
  },
}

export default AttributeUtils
